<template>
  <label class="input-inside-chat-label">
    <span v-if="text">{{ text }}</span>
    <textarea
      :value="value"
      class="textarea-inside-chat"
      :class="{ 'error': validate.$invalid && validate.$dirty }"
      @input="changeInput"
    />
  </label>
</template>

<script>
export default {
  name: 'ChatTextarea',
  props: {
    text: {
      type: String,
      default: null
    },
    value: {
      type: String,
      default: ''
    },
    validate: {
      type: Object,
      default () { return {} }
    }
  },

  methods: {
    changeInput ($event) {
      this.$emit('input', $event.target.value)
      this.validate.$touch()
    }
  }
}
</script>
